// You can write more code here

/* START OF COMPILED CODE */

import Phaser from 'phaser';
import BtnPauseMusic from '../core/prefabs/BtnPauseMusic';
import BtnPauseAudio from '../core/prefabs/BtnPauseAudio';
import BtnPauseClose from '../core/prefabs/BtnPauseClose';
/* START-USER-IMPORTS */
import { app } from '../core/App';
/* END-USER-IMPORTS */

export default class PauseMenu extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // menu
    const menu = scene.add.container(0, 0);
    this.add(menu);

    // menuBg
    const menuBg = scene.add.image(0, 0, 'common', 'popup-pause.png');
    menu.add(menuBg);

    // btnPauseMusic
    const btnPauseMusic = new BtnPauseMusic(scene, 120, 0);
    menu.add(btnPauseMusic);

    // btnPauseAudio
    const btnPauseAudio = new BtnPauseAudio(scene, -120, 0);
    menu.add(btnPauseAudio);

    // btnPauseClose
    const btnPauseClose = new BtnPauseClose(scene, 272, -130);
    menu.add(btnPauseClose);

    this.cover = cover;
    this.menu = menu;
    this.menuBg = menuBg;
    this.btnPauseMusic = btnPauseMusic;
    this.btnPauseAudio = btnPauseAudio;
    this.btnPauseClose = btnPauseClose;

    /* START-USER-CTR-CODE */
    this.menuBg.setInteractive();
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private menu: Phaser.GameObjects.Container;
  private menuBg: Phaser.GameObjects.Image;
  private btnPauseMusic: BtnPauseMusic;
  private btnPauseAudio: BtnPauseAudio;
  private btnPauseClose: BtnPauseClose;
  public menuStartY: number = -600;
  public menuEndY: number = 0;

  /* START-USER-CODE */

  private closeCallback: (() => void) | undefined;

  public activate(closeCallback?: () => void) {
    this.closeCallback = closeCallback;

    this.transitionIn();
  }

  protected transitionIn() {
    this.btnPauseAudio.setButtonState(!this.getSFXAudioIsMuted());
    this.btnPauseMusic.setButtonState(!this.getMusicAudioIsMuted());

    this.btnPauseClose.once(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);
    this.btnPauseAudio.on(Phaser.Input.Events.POINTER_UP, this.toggleSFXAudio, this);
    this.btnPauseMusic.on(Phaser.Input.Events.POINTER_UP, this.toggleMusicAudio, this);

    this.cover.alpha = 0;
    this.scene.add.tween({
      targets: this.cover,
      alpha: { from: 0, to: 1 },
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.menu.y = this.menuStartY;
    this.scene.add.tween({
      targets: this.menu,
      y: { from: this.menuStartY, to: this.menuEndY },
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      delay: 250
    });

    this.scene.time.delayedCall(250, () => {
      this.cover.setInteractive();
      this.cover.once(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);
    });
  }

  protected transitionOut() {
    this.cover.disableInteractive();
    this.cover.off(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);
    this.btnPauseClose.off(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);
    this.btnPauseAudio.off(Phaser.Input.Events.POINTER_UP, this.toggleSFXAudio, this);
    this.btnPauseMusic.off(Phaser.Input.Events.POINTER_UP, this.toggleMusicAudio, this);

    this.scene.tweens.killTweensOf([this.menu, this.cover]);

    this.scene.add.tween({
      targets: this.menu,
      y: this.menuStartY,
      duration: 400,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets: this.cover,
      alpha: 0,
      duration: 250,
      delay: 400,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.scene.time.delayedCall(650, () => {
      this.closeCallback?.();
    });
  }

  protected getSFXAudioIsMuted(): boolean {
    return app.audioHandler.getChannelMute('sfx');
  }

  protected getMusicAudioIsMuted(): boolean {
    return app.audioHandler.getChannelMute('music');
  }

  protected toggleSFXAudio() {
    let isMuted = this.getSFXAudioIsMuted();
    app.audioHandler.setChannelMute('sfx', !isMuted);
  }

  protected toggleMusicAudio() {
    let isMuted = this.getMusicAudioIsMuted();
    app.audioHandler.setChannelMute('music', !isMuted);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
